import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidDescription } from '../helpers/is-valid-description/is-valid-description';

export function descriptionValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const isValid = isValidDescription(value);

    return isValid ? null : { invalid: true };
  };
}
